export const mapperToPurchaseRequest = (data: any) => {
    return [
        {
          id: "dados",
          value: data.codemp
            ? {
                codemp: data.codemp,
                nomemp: data.nomemp,
                sigemp: data.sigemp,
              }
            : null,
          required: true,
        },
        {
          id: "filiais",
          value: data.codfil
            ? {
                codfil: data.codfil,
                nomfil: data.nomfil,
              }
            : null,
          required: true,
        },
        {
          id: 'itens',
          value: data.itens ? data.itens?.map((item:any) => mapperToPurchaseRequestItem(item)) : [],
          required: true,
        },
      ];
}

export const mapperToPurchaseRequestItem = (data: any) => {
    return [
        {
          id: 'produto',
          value: data.tipo === 'produto' ? {
            codpro: data.coditem,
            despro: data.desitem,
          } : null,
          required: false,
        },
        {
          id: 'servico',
          value: data.tipo === 'servico' ? {
            codser: data.coditem,
            desser: data.desitem,
          } : null,
          required: false,
        },
        {
          id: 'derivacao',
          value: data.codder ? {
            codder: data.codder,
            desder: data.desder,
          } : null,
          required: false,
        },
        {
          id: 'tipo',
          value: data.tipo ? {
            tipo: data.tipo,
          } : {
            tipo: 'produto',
          },
          required: true,
        },
        {
          id: "deposito",
          value: data.coddep
            ? {
                coddep: data.coddep,
                desdep: data.desdep,
              }
            : null,
          required: data.tipo === 'servico' ? false : true,
        },
        {
          id: 'transacao',
          value: data.codtns ? {
            codtns: data.codtns,
            destns: data.destns,
          } : null,
          required: true,
        },
        {
          id: 'datprv',
          value: {
            datprv: data.datprv || '',
          },
          required: true,
        },
        {
          id: 'unimed',
          value: data.unimed ?? '',
          required: true,
        },
        {
          id: 'presol',
          value: {
            presol: data.presol ?? 1,
          },
          required: true,
        },
        {
          id: 'qtdsol',
          value: {
            qtdsol:  data.qtdsol ?? 1,
          },
          required: true,
        },
        {
          id: 'seqsol',
          value: {
            seqsol: data.seqsol ?? 1,
          },
          required: true,
        },
        {
          id: 'obssol',
          value: {
            obssol:  data.obssol ?? '',
          },
          required: false,
        },
        {
          id: "centrosCusto",
          value: data.codccu
            ? {
                codccu: data.codccu,
                desccu: data.desccu,
              }
            : null,
          required: true,
        },
      ];
}
